import { useEffect, useState } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import './App.css';
import Loader from './components/loader/Loader';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import Dashboard from './pages/dashboard/Dashboard';

import firebase from './components/firebase/Firebase'
import Search from './pages/search/Search';

function App() {
	const [user, setUser] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		firebase.auth().onAuthStateChanged(user => {
			if (!user) {
				setUser(null)
				setLoading(false)
				} else {
					firebase.database().ref('users/' + user.uid).once('value', snapshot => {
						const userData = snapshot.val();
						if (!userData) {
							// Benutzer wurde endgültig gelöscht (Hard Delete) - kein Zugang
							setUser({ blocked: true, uid: user.uid });
						} else {
							setUser({ ...userData, uid: user.uid });
						}
						setLoading(false)
					}).catch(err => {
						console.log(err)
						alert("something went wrong, please try again later")
					})
			}
		})
	}, [])

	if (loading) {
		return (
			<div className="App">
				<Loader />
			</div>
		)
	}

	if (!user) {
		return (
			<div className="App">
				<BrowserRouter>
					<Switch>
						<Route path="/register" render={(props) => <Register {...props} />} />
						<Route path="/" render={(props) => <Login {...props} />} />
					</Switch>
				</BrowserRouter>
			</div>
		)
	}

	// Blockierte Benutzer (Hard Deleted) - kein Zugang zur App
	if (user.blocked) {
		return (
			<div className="App">
				<div style={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					minHeight: '100vh',
					padding: '20px',
					textAlign: 'center'
				}}>
					<h2 style={{ color: '#333', marginBottom: '15px' }}>Kein Zugang</h2>
					<p style={{ color: '#666', fontSize: '16px', maxWidth: '400px', lineHeight: '1.5' }}>
						Ihr Konto ist nicht mehr aktiv. Bitte kontaktieren Sie die Administration.
					</p>
					<button
						style={{
							marginTop: '20px',
							padding: '10px 30px',
							background: '#dc3545',
							color: 'white',
							border: 'none',
							borderRadius: '5px',
							cursor: 'pointer',
							fontSize: '14px'
						}}
						onClick={() => firebase.auth().signOut()}
					>
						Abmelden
					</button>
				</div>
			</div>
		);
	}

	if (user.isAdmin || user.isSuperAdmin) {
		return (
			<div className="App">
				<BrowserRouter>
					<Switch>
						{/*<Route path="/register" render={(props) => <Register {...props} />} />
						<Route path="/login" render={(props) => <Login {...props} />} />*/}
						<Route exact path="/" render={(props) => <Search {...props} user={user} />} />
						<Route exact path="/deleted" render={(props) => <Search {...props} isViewingDeleted user={user} />} />
						<Route exact path="/dashboard/:uid" render={(props) => <Dashboard {...props} user={user} />} />
					</Switch>
				</BrowserRouter>
			</div>
		);
	}

	return (
		<div className="App">
			<BrowserRouter>
				<Switch>
					{/*<Route path="/register" render={(props) => <Register {...props} />} />
					<Route path="/login" render={(props) => <Login {...props} />} />*/}
					<Route path="/" render={(props) => <Dashboard {...props} user={user} />} />
				</Switch>
			</BrowserRouter>
		</div>
	);
}

export default App;
